import React from "react";
import { TouchableOpacity } from "react-native";
import { Container, OuterContainer } from "./styles";
import { CloseIcon } from "myplan/components/Icon";

type CloseButtonProps = {
    onPress?: () => void;
};

const CloseButton = ({ onPress }: CloseButtonProps) => {
    const Icon = CloseIcon;
    const width = "40%";

    return (
        <OuterContainer>
            <TouchableOpacity onPress={onPress}>
                <Container pointerEvents="box-none">
                    <Icon width={width} height={width} />
                </Container>
            </TouchableOpacity>
        </OuterContainer>
    );
};

export default CloseButton;
